export default {
  baseUrl: process.env.NODE_ENV === 'production'?'https://back.openc.beidousdk.com':'https://back.openc.beidousdk.com',
  // 单点登录需要给cookie设置domain,让cookie共享
  domain: process.env.NODE_ENV === 'production' ? '.beidousdk.com' : '',
  baseConsoleLink: process.env.NODE_ENV === 'production' ? 'https://openc.beidousdk.com' : 'https://openc.beidousdk.com',
  // baseUrl: process.env.NODE_ENV === 'production'?'http://back.openc.pg8.ink':'http://back.openc.pg8.ink',
  // // 单点登录需要给cookie设置domain,让cookie共享
  // domain: process.env.NODE_ENV === 'production' ? '.pg8.ink' : '',
  // baseConsoleLink: process.env.NODE_ENV === 'production' ? 'http://open.console.pg8.ink' : 'http://open.console.pg8.ink',
} 